import React from 'react';
import one from '../../assest/blogsteam.png';
import two from '../../assest/post.png';
import {
  FaUser,
  FaComments,
  FaLaptopCode,
  FaCalendarAlt,
  FaSearch,
} from 'react-icons/fa';

const BlogsTeams = () => {
  const Post = [
    {
      id: 1,
      img: two,
      date: '18 Dec, 2024',
      title: 'Keep Your Business Safe & Endure High Availability',
    },
    {
      id: 2,
      img: two,
      date: '18 Dec, 2024',
      title: 'Keep Your Business Safe & Endure High Availability',
    },
    {
      id: 3,
      img: two,
      date: '18 Dec, 2024',
      title: 'Keep Your Business Safe & Endure High Availability',
    },
    {
      id: 4,
      img: two,
      date: '18 Dec, 2024',
      title: 'Keep Your Business Safe & Endure High Availability',
    },
  ];

  return (
    <section className="py-4">
      <div className="container">
        {/* Main blog content */}
        <div className="row">
          <div className="col-lg-8 mb-4 mb-lg-0">
            <img src={one} alt="Blog visual" className="img-fluid rounded" />

            <div className="d-flex flex-wrap mt-3 gap-3 gap-md-4 align-items-center text-muted">
              <div className="d-flex align-items-center gap-2">
                <FaUser />
                <span>By Admin</span>
              </div>
              <div className="d-flex align-items-center gap-2">
                <FaComments />
                <span>2 Comments</span>
              </div>
              <div className="d-flex align-items-center gap-2">
                <FaLaptopCode />
                <span>IT Services</span>
              </div>
            </div>

            <div className="bolgs-text mt-4">
              <h2 style={{ color: '#17012C' }} className="mb-3">
                Profitable business makes your profit
              </h2>
              <p className="mb-3">
                Consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
                consequat. Duis aute irure dolor in reprehenderit.
              </p>
              <p className="mb-3">
                Ipsum dolor sit amet, consectetur adipiscing elit. Fusce eleifend porta arcu. In hac habitasse platea
                dictumst. In lacus libero, faucibus at malesuada sagittis, placerat eros. Sed tincidunt augue ac ante
                rutrum, sodales augue consequat.
              </p>
              <p className="mb-3">
                Nulla facilisi. Vestibulum tristique sem in eros eleifend imperdiet. Donec quis convallis neque. In id
                lacus pulvinar, vulputate lectus. Ut viverra bibendum lorem, at tempus nibh mattis in. Sed a massa eget
                lacus consequat auctor.
              </p>
            </div>
          </div>

          <div className="col-lg-4">
            {/* Search Box */}
            <div
              className="search shadow-sm p-3 rounded mb-4"
              style={{ boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)' }}
            >
              <h3 style={{ color: '#17012C' }} className="h5">Search</h3>
              <div
                style={{
                  width: '60px',
                  height: '3px',
                  backgroundColor: '#B91C1C',
                  marginBottom: '10px',
                }}
              ></div>

              <div className="input-group">
                <input
                  type="text"
                  className="form-control border-end-0"
                  placeholder="Search..."
                  style={{ boxShadow: 'none' }}
                />
                <span
                  className="input-group-text border-start-0"
                  style={{ backgroundColor: 'red', color: 'white' }}
                >
                  <FaSearch />
                </span>
              </div>
            </div>

            {/* Recent Post */}
            <div
              className="post shadow-sm p-3 rounded mb-4"
              style={{ boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)' }}
            >
              <h3 style={{ color: '#17012C' }} className="h5">Recent Post</h3>
              <div
                style={{
                  width: '60px',
                  height: '2px',
                  backgroundColor: 'red',
                  marginBottom: '10px',
                }}
              ></div>

              {Post.map((item) => (
                <div key={item.id} className="d-flex align-items-start gap-3 mb-3">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="img-fluid rounded"
                    style={{ width: '80px', height: '60px', objectFit: 'cover' }}
                  />
                  <div>
                    <div
                      className="d-flex align-items-center text-muted mb-1"
                      style={{ fontSize: '0.75rem' }}
                    >
                      <FaCalendarAlt className="me-1" style={{ color: '#B91C1C' }} />
                      <span style={{ color: '#B91C1C' }}>{item.date}</span>
                    </div>
                    <p className="mb-0" style={{ color: '#333', fontSize: '0.875rem' }}>{item.title}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Tab Button Section */}
            <div
              className="tab-buttons shadow-sm p-3 rounded"
              style={{ boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)' }}
            >
              <h5 className="mb-3" style={{ color: '#17012C' }}>Tabs</h5>

              <div className="tabs d-flex flex-wrap gap-2" style={{ marginTop: 0 }}>
                <button className="btn btn-outline-danger btn-sm py-1 px-2">Security</button>
                <button className="btn btn-outline-danger btn-sm py-1 px-2">Business</button>
                <button className="btn btn-outline-danger btn-sm py-1 px-2">Digital</button>
                <button className="btn btn-outline-danger btn-sm py-1 px-2">Digital</button>
                <button className="btn btn-outline-danger btn-sm py-1 px-2">Technology</button>
                <button className="btn btn-outline-danger btn-sm py-1 px-2">Change</button>
                <button className="btn btn-outline-danger btn-sm py-1 px-2">Video</button>
                <button className="btn btn-outline-danger btn-sm py-1 px-2">Digital</button>
                <button className="btn btn-outline-danger btn-sm py-1 px-2">UI/UX Design</button>
                <button className="btn btn-outline-danger btn-sm py-1 px-2">Startup</button>
                <button className="btn btn-outline-danger btn-sm py-1 px-2">Services</button>
              </div>
            </div>
          </div>
        </div>

        {/* Image row */}
        <div className="row mt-4">
          <div className="col-md-6 col-lg-4 mb-3 mb-md-0">
            <img src={one} alt="Thumbnail 1" className="img-fluid rounded" />
          </div>
          <div className="col-md-6 col-lg-4">
            <img src={one} alt="Thumbnail 2" className="img-fluid rounded" />
          </div>
        </div>

        {/* Additional paragraph */}
        <div className="row mt-3">
          <div className="col-lg-8">
            <p className="mb-0">
              Consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
              consequat. Duis aute irure dolor in reprehenderit. Consectetur adipisicing elit, sed do eiusmod
              tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
              ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogsTeams;